import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { Button, ModalProvider, useUserService } from '@abroad/components'
import {
  FreePlanNoSurvey,
  QuestProsperityResult,
  // QuestWisdomResult,
} from '../Home'
import { CategoryModal } from '../assessmentResult'
import { surveyType } from '../../utils/constants'
import QuestSection from './QuestSections'
import SupportModal from './SupportModal'
import { gtmViewExperienceBookIndividualSessionAction } from './gtmfunctions'

const QuestComplimentarySupport = ({
  questId,
  questTitle,
  questSteps,
  hasComplimentarySupport,
}) => {
  const history = useHistory()
  const { user } = useUserService()
  const [showIntentionsModal, setShowIntentionsModal] = useState(false)
  const [showSupportModal, setShowSupportModal] = useState(false)
  const scheduleButtonEnabled =
    questSteps?.steps?.step4?.scheduleButtonEnabled ?? false
  const isAllQuestSessionsScheduled =
    questSteps?.isAllQuestSessionsScheduled ?? false

  const handleBookSessionsClick = () => {
    gtmViewExperienceBookIndividualSessionAction(
      questId,
      questTitle || 'Experience Book Individual Session',
      user?._id,
    )

    if (scheduleButtonEnabled) {
      history.push(`/your-experiences/${questId}/session-list`)
    } else {
      setShowSupportModal(true)
    }
  }

  const supportDescription = (
    <>
      <p className='s7 mb-4 quest-support-description'>
        Before your experience, you may schedule a 1:1 Preparation Session with
        an Abroad Wisdom Guide to help you connect deeply with your intentions
        and prepare for the trip. Upon your return, you&apos;ll also have the
        opportunity to debrief and integrate your experience with your Wisdom
        Guide. This is entirely optional, however most participants who take
        advantage of it find it highly valuable.
      </p>
      <p className='s7 mb-4 quest-support-description'>
        To start the process, please complete the True Prosperity Assessment
        below, and you will be paired with a Wisdom Guide after the Orientation
        Session.
      </p>
    </>
  )

  const supportTasks = [
    ...(!isAllQuestSessionsScheduled
      ? [
          {
            title: 'Book Your Individual Sessions',
            imageSrc: '/assets/quest-important-items/review-itinerary.webp',
            onClick: handleBookSessionsClick,
            text: 'Book Now',
          },
        ]
      : []),
    {
      title: 'Clarify Your Intentions',
      imageSrc: '/assets/quest-important-items/upload-travel-documents.webp',
      text: 'Review Now',
      onClick: () => setShowIntentionsModal(true),
    },
  ]

  const handleCloseIntentionsModal = () => {
    setShowIntentionsModal(false)
  }

  const handleRecordIntentionsNow = () => {
    setShowIntentionsModal(false)
    history.push(`/your-experiences/${questId}/all-intentions`)
  }

  const prosperityTaken = user?.prosperityTaken

  return (
    <section className='quest-dashboard-section mt-64px'>
      {hasComplimentarySupport && !prosperityTaken && (
        <>
          <h3 className='s3 mb-3 quest-support-title'>Complimentary Support</h3>
          {supportDescription}
        </>
      )}

      {
        prosperityTaken ? (
          <ModalProvider>
            <CategoryModal />
            <QuestProsperityResult />
          </ModalProvider>
        ) : (
          <>
            <FreePlanNoSurvey
              type={surveyType.PROSPERITY}
              isRenderOnAwarenessPage={false}
              prosperityPage={false}
              isQuestHomePage={true}
            />
          </>
        )
        // : user?.wisdomTaken ? (
        //   <ModalProvider>
        //     <CategoryModal />
        //     <QuestWisdomResult />
        //   </ModalProvider>
        // )
      }

      {hasComplimentarySupport &&
        supportTasks.map((task, index) => (
          <QuestSection key={index} task={task} />
        ))}

      <SupportModal
        showModal={showSupportModal}
        handleClose={() => setShowSupportModal(false)}
        message='Individual session scheduling isn’t available yet!'
      />

      <Modal
        show={showIntentionsModal}
        onHide={handleCloseIntentionsModal}
        centered
        className='payment-modal'>
        <Modal.Header className='payment-modal-header d-flex justify-content-center'>
          <h3 className='payment-modal-title mb-0'>Clarify Your Intentions</h3>
        </Modal.Header>
        <Modal.Body className='payment-modal-body'>
          <div className='s7'>
            If you&apos;ll be meeting with an Abroad Wisdom Guide, you may wish
            to wait and record your intentions together during that session. Or,
            if you&apos;d prefer, you can record them now.
          </div>
        </Modal.Body>
        <Modal.Footer className='border-0 d-flex justify-content-center pt-0'>
          <div className='d-inline-flex flex-column'>
            <Button
              variant='saffron'
              onClick={handleCloseIntentionsModal}
              className='px-3 text-white mb-2'
              size='sm'>
              I&apos;ll wait until my session
            </Button>
            <Button
              variant='secondary-light'
              onClick={handleRecordIntentionsNow}
              className='px-3 secondary-popup-button'
              size='sm'>
              I&apos;ll record my intentions now
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </section>
  )
}

export default QuestComplimentarySupport
